<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="blue-grey lighten-2">
            <v-toolbar-title>{{ $t('RESET_TITLE') }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-alert :value="!!error" type="warning">
            {{ error }}
          </v-alert>

          <v-card-text v-if="!token">
            <p>{{ $t('RESET_LINK_INCOMPLETE') }}</p>
          </v-card-text>
          <v-card-actions v-if="!token">
            <v-spacer></v-spacer>
            <router-link to="/forgot-password" style="margin-right:16px;margin-bottom:8px">
              {{ $t('RESET_REQUEST_NEW') }}
            </router-link>
          </v-card-actions>

          <v-card-text v-else-if="success">
            <v-alert :value="true" type="success" outlined>
              {{ $t('RESET_SUCCESS') }}
            </v-alert>
          </v-card-text>

          <template v-else>
            <v-card-text>
              <v-form @submit.prevent="onSubmit">
                <v-text-field
                  v-model="newPassword"
                  prepend-icon="lock"
                  :label="$t('RESET_NEW_PWD_LABEL')"
                  type="password"
                  minlength="8"
                  required
                  @keyup.enter="onSubmit"
                ></v-text-field>
                <v-text-field
                  v-model="repeat"
                  prepend-icon="lock"
                  :label="$t('RESET_REPEAT_LABEL')"
                  type="password"
                  minlength="8"
                  required
                  @keyup.enter="onSubmit"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark color="amber darken-4" :loading="loading" @click="onSubmit">
                {{ $t('RESET_SUBMIT') }}
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { confirmPasswordReset } from '../services/login.service';

export default {
  name: 'ResetPassword',
  data() {
    return {
      token: '',
      newPassword: '',
      repeat: '',
      error: '',
      loading: false,
      success: false,
    };
  },
  mounted() {
    this.token = this.$route.query.token || '';
  },
  methods: {
    async onSubmit() {
      this.error = '';
      if (this.newPassword !== this.repeat) {
        this.error = this.$t('RESET_MISMATCH');
        return;
      }
      if (this.newPassword.length < 8) {
        this.error = this.$t('RESET_TOO_SHORT');
        return;
      }
      if (this.loading) return;
      this.loading = true;
      try {
        const resp = await confirmPasswordReset(this.token, this.newPassword, this.$i18n.locale);
        if (resp.status === 'success') {
          this.success = true;
          setTimeout(() => this.$router.push('/login'), 2000);
        } else {
          this.error = resp.message || this.$t('RESET_GENERIC_ERROR');
        }
      } catch (e) {
        this.error = this.$t('RESET_GENERIC_ERROR');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
